import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:attr',
    name: 'compile',
    property: 'data-compile',
    targetSelector: 'self',
    visible: 'field-hide-all',
    default_value: 'false',
  },
  {
    type: 'html:attr',
    name: 'widget',
    property: 'data-widget',
    refreshType: 'all',
    targetSelector: '.module',
    default_value: 'reviews',
    options: [
      {
        key: 'reviews',
        value: 'Reviews',
      },
      {
        key: 'badge',
        value: 'Star Badge',
      },
      {
        key: 'productListBadge',
        value: 'Product List Badge',
      },
      {
        key: 'wishList',
        value: 'Wish List',
      },
      {
        key: 'socialShare',
        value: 'Social Share',
      },
      {
        key: 'favorite',
        value: 'Favorite Icon',
      },
    ],
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];

/**
 * Opinew Reviews Atom Module
 */
export class GpGrowave extends GpThirdParty {
  public $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Growave';
  }

  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'growave';
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
}
